import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsEvents} from "../../shared/dto/aps.events";
import {SignalRHub} from "../hubs/signalr-hub";
import * as angular from 'angular';
import HubServiceName, {HubService} from "../hubs/hub.service";

export interface CheckListInstancesHub extends SignalRHub {
  joinGroup(plantId: string, shopId: string): Promise<any>;
  leaveGroup(plantId: string, shopId: string): Promise<any>;
}

export interface CheckListInstancesHubCreator {
  createCheckListInstancesHub(shopId: string,
                              plantId: string,
                              onUpdate: (update: apsEvents.CheckListInstancesUpdated) => void,
                              onInstance: (instance: apsViewModels.CheckListInstanceItemEvent) => void): CheckListInstancesHub;
}

class CheckListInstancesHubCreatorImpl implements CheckListInstancesHubCreator {

  private hubService: HubService;

  constructor(hubService: HubService) {
    this.hubService = hubService;
  }

  createCheckListInstancesHub(plantId: string,
                              shopId: string,
                              onUpdate: (update: apsEvents.CheckListInstancesUpdated) => void,
                              onInstance: (instance: apsViewModels.CheckListInstanceItemEvent) => void): CheckListInstancesHub {

    return this.hubService.createHub<CheckListInstancesHub>('checkListInstance', {
      listeners: {
        instanceEventFired: onInstance,
        instancesUpdated: onUpdate
      },
      allowMultipleListeners: true,
      methods: ['leaveGroup', 'joinGroup'],
      postConnect: (hub: CheckListInstancesHub) => {
        hub.invokeWithRetry(() => hub.joinGroup(plantId, shopId));
      }
    });
  }
}

export default angular.module('aps.hubs.checkListInstances', [HubServiceName])
  .service('checkListInstancesHubCreator', CheckListInstancesHubCreatorImpl)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/checkLists/checkListInstances.hub.ts